import { APP_ROUTES } from "@src/constants";
import { useApplicationContext } from "@src/context/ApplicationContext";
import { useNavigateWithUTM } from "@src/hooks/useNavigateWithUTM";
import type { Provider } from "@src/interfaces/provider.interface";
import { useCallback, useState } from "react";

export const useLocalCenterScheduling = () => {
  const { data } = useApplicationContext();
  const navigate = useNavigateWithUTM();
  const [showProviderNotFoundModal, setShowProviderNotFoundModal] = useState(false);

  const isMeetTheTeamOrigin = data.providerSelectionSource === APP_ROUTES.MEET_THE_TEAM;

  const handleProviderSearchResult = useCallback(
    (filteredProviderList: Provider[], selectedProvider: Provider | null) => {
      if (!isMeetTheTeamOrigin) {
        return false;
      }

      if (
        selectedProvider &&
        !filteredProviderList.some((p) => p.providerId === selectedProvider.providerId)
      ) {
        setShowProviderNotFoundModal(true);
        return true;
      }

      if (selectedProvider) {
        navigate(APP_ROUTES.PROVIDER_PROFILE);
        return true;
      }

      return false;
    },
    [isMeetTheTeamOrigin, navigate],
  );

  const handleProviderNotFoundSeeMoreProviders = useCallback(() => {
    setShowProviderNotFoundModal(false);
    navigate(APP_ROUTES.FIND_PROVIDER);
  }, [navigate]);

  const closeProviderNotFoundModal = useCallback(() => {
    setShowProviderNotFoundModal(false);
  }, []);

  return {
    isMeetTheTeamOrigin,
    showProviderNotFoundModal,
    handleProviderSearchResult,
    handleProviderNotFoundSeeMoreProviders,
    closeProviderNotFoundModal,
  };
};
